import USER_CONSENT_RESPONSE from '@api/lendingAPI/__fixtures__/credit_card/tell_money_user_consents.fixture.json';

export const useGetTellMoneyUserConsent = () => {
    return USER_CONSENT_RESPONSE.consents;
};
